import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Eyebrow } from "./Motion";
import { TrackLines } from "./TrackLines";

export const PageHero = ({ eyebrow, lines, lead, aside, testid, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 120]);
  return (
    <section ref={ref} className="grain relative overflow-hidden px-5 pb-20 pt-36 sm:px-8 lg:pb-28 lg:pt-44" data-testid={testid}>
      <motion.div style={{ y }} className="absolute inset-0"><TrackLines /></motion.div>
      <div className="relative mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <motion.div initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} className="mb-8">
            {typeof eyebrow === "string" ? <Eyebrow className="text-[#c2380f]">{eyebrow}</Eyebrow> : eyebrow}
          </motion.div>
          <MaskLines onLoad lines={lines} className="font-display text-[2.9rem] font-bold leading-[0.92] tracking-[-0.035em] sm:text-7xl lg:text-[6.4rem]" />
          {lead && (
            <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.8 }}
              className="mt-10 max-w-xl text-base leading-relaxed text-[#3d3a35] md:text-lg">{lead}</motion.p>
          )}
          {children}
        </div>
        {aside && (
          <motion.div initial={{ opacity: 0, rotate: -4, y: 30 }} animate={{ opacity: 1, rotate: 0, y: 0 }} transition={{ delay: 0.5, duration: 1 }}
            className="lg:col-span-4 lg:self-end">{aside}</motion.div>
        )}
      </div>
    </section>
  );
};
